import {
  Button,
  Dialog,
  Paper,
  Grid,
  IconButton,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  LinearProgress,
  Snackbar,
  Alert,
  Slide,
  DialogTitle,
  DialogActions,
  useMediaQuery,
  tableCellClasses,
  FormControlLabel,
  Checkbox,
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
  Chip,
  Divider,
  Switch,
} from '@mui/material';
import { useTheme } from '@emotion/react';
import CloseIcon from '@mui/icons-material/Close';
import { Form, Formik } from 'formik';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import * as Yup from 'yup';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Container } from 'reactstrap';

import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import UIContext from '../../context/UIContext';
import axios from '../../utils/axios';

const StyledTableCell = styled(TableCell)({
  color: 'white !important',
  border: 'solid 1px #dee2e6',
  fontWeight: '800',
  textAlign: 'center',
  backgroundColor: '#47A992',
  padding: 'none',
  whiteSpace: 'nowrap',
});

const DefectCategoryInitialValue = {
  CategoryDescription: '',
  Active: 'yes',
};

const filterInitialValue = {
  searchTerm: '',
  Active: true,
};

const DefectCategory = () => {
  const [filterData, setFilterData] = useState(filterInitialValue);
  const [defectCategoryTableData, setDefectCategoryTableData] = useState([]);
  const [defectCategorys, setDefectCategorys] = useState([]);
  const [UserId, setUserId] = useState(null);

  const [initialValue, setInitialValue] = useState(DefectCategoryInitialValue);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [openDelete, setOpenDelete] = useState(false);

  // snackbar context
  const { openSnackBar, showLoading, hideLoading } = useContext(UIContext);

  // api fetch data
  useEffect(() => {
    const UserId = sessionStorage.getItem('UserId');
    setUserId(UserId);
    getAllDefectCategory();
  }, []);

  const defectCategoryValidationSchema = useMemo(
    () =>
      Yup.object().shape({
        CategoryDescription: Yup.string()
          .trim()
          .min(3, ({ min }) => `Minimum ${min} characters required`)
          .max(100, ({ max }) => `Cannot exceed more than ${max} characters`)
          .transform((value) => (value ? value.toLowerCase() : value))
          .notOneOf(
            defectCategorys
              .filter((Category) => Category.CategoryId !== initialValue.CategoryId)
              .map((Category) => Category.CategoryDescription?.trim()?.toLowerCase()),
            'Category Description Already Exists'
          )
          .required('Enter Category Description'),
        Active: Yup.string().oneOf(['yes', 'No'], 'Please select Yes or No').required('Please select Yes or No'),
      }),
    [defectCategorys, initialValue]
  );

  async function getAllDefectCategory() {
    try {
      showLoading();
      const response = await axios.get('Master/DefectCategory/GetAllDefectCategory');
      setDefectCategorys(response.data);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  async function InsertDefectCategory(values) {
    try {
      showLoading();
      const response = await axios.post('Master/DefectCategory/AddDefectCategory', { ...values, UserId });
      getAllDefectCategory();
      openSnackBar('Defect Category Added Successfully!');
      // setFilterData(filterInitialValue);
      setEdit(false);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
    setOpen(false);
  }

  const UpdateDefectCategory = async (values) => {
    try {
      showLoading();
      await axios.post(`Master/DefectCategory/UpdateDefectCategory`, { ...values, UserId });
      getAllDefectCategory();
      setInitialValue(DefectCategoryInitialValue);
      openSnackBar('Defect Category Updated Successfully!', 'warning');
      // setFilterData(filterInitialValue);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    setOpen(false);
    setEdit(false);
    hideLoading();
  };

  const DeleteDefectCategory = async () => {
    try {
      showLoading();
      await axios.delete(`Master/DefectCategory/DeleteDefectCategory/${deleteId}`);
      const newDefectCategory = defectCategorys.filter((defectCategory) => defectCategory.CategoryId !== deleteId);
      setDefectCategorys(newDefectCategory);
      setDefectCategoryTableData(newDefectCategory);
      openSnackBar('Defect Category Deleted Successfully!', 'warning');
      // setFilterData(filterInitialValue);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    handleCloseDelete();
    setDeleteId(null);
    hideLoading();
  };

  const handleFilterDataChange = (name, value) => {
    setFilterData({ ...filterData, [name]: value });
  };
  useEffect(() => {
    const newTableData = defectCategorys.filter(
      (defectCat) =>
        defectCat.CategoryDescription.toLowerCase().includes(filterData.searchTerm?.toLowerCase()) &&
        defectCat.Active?.toLowerCase()?.trim() === (filterData.Active ? 'yes' : 'no')
    );
    if (page > 0) setPage(0);
    setDefectCategoryTableData(newTableData);
  }, [defectCategorys, filterData]);

  // function handleDefectCategoryFilterSearch(filtertext) {
  //   setDefectCategoryFilterSearch(filtertext);

  //   const newDivsionTableData = defectCategorys.filter((defectCat) =>
  //     defectCat.CategoryDescription.toLowerCase().includes(filtertext.toLowerCase())
  //   );
  //   if (page > 0) setPage(0);
  //   setDefectCategoryTableData(newDivsionTableData);
  // }
  const handleCloseDelete = () => {
    setOpenDelete(false);
    setDeleteId(null);
  };

  const handleCloseDialog = () => {
    setOpen(!open);
    setEdit(false);
    setInitialValue(DefectCategoryInitialValue);
  };

  // pagination
  const { emptyRows, totalRows, currentPage } = useMemo(() => {
    const totalRows = defectCategoryTableData.length;
    const totalPages = Math.ceil(totalRows / rowsPerPage);
    const currentPage = Math.max(0, Math.min(page, totalPages - 1));
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, totalRows - page * rowsPerPage);

    return { emptyRows, totalRows, currentPage };
  }, [defectCategoryTableData, page, rowsPerPage]);

  return (
    <>
      <Container maxWidth={'xl'} sx={{ pt: 2 }} elevation={3}>
        {/* table header */}
        <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2}>
          <Typography
            variant="h5"
            p={1}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={2}
            pl={2}
            color="white"
            sx={{
              // borderRadius: 50,
              background: '#47A992',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              DEFECT CATEGORY MASTER
            </Typography>
          </Typography>
        </Grid>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent={'space-between'}
          alignItems={'center'}
          spacing={2}
          my={3}
          px={3}
        >
          <TextField
            type="text"
            variant="outlined"
            color="secondary"
            label="Search"
            size="small"
            onChange={(e) => {
              handleFilterDataChange('searchTerm', e.target.value);
            }}
            value={filterData.searchTerm}
          />
          <Stack direction="row" alignItems="center" spacing={2}>
            <Typography variant="subtitle2" fontWeight="bold">
              Active
            </Typography>

            {/* Toggle Switch with "Yes" / "No" */}
            <FormControlLabel
              control={
                <Switch
                  checked={filterData.Active}
                  onChange={(e) => {
                    handleFilterDataChange('Active', !filterData.Active);
                  }}
                  color="success"
                />
              }
              label={filterData.Active ? 'Yes' : 'No'}
            />
            <Divider orientation="vertical" flexItem />
            <Button
              variant="outlined"
              color="secondary"
              sx={{ boxShadow: 1 }}
              onClick={() => setOpen(!open)}
              startIcon={<PlaylistAddIcon />}
            >
              Add Defect Category
            </Button>
          </Stack>
        </Stack>
        <TableContainer sx={{ borderRadius: '7px', maxHeight: '450px' }} component={Paper} elevation={2}>
          <Table className="table-bordered" size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <StyledTableCell align="center">S.No</StyledTableCell>
                <StyledTableCell align="left">Defect Category</StyledTableCell>
                <StyledTableCell align="center">Active</StyledTableCell>
                <StyledTableCell align="center">Actions</StyledTableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {(rowsPerPage > 0
                ? defectCategoryTableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : defectCategoryTableData
              ).map((defectCategory, i) => (
                <TableRow key={defectCategory.CategoryId} hover>
                  <TableCell align="center">{page * rowsPerPage + (i + 1)}</TableCell>
                  {/* <TableCell align="center">{defectCategory.SNo}</TableCell> */}
                  <TableCell align="left">{defectCategory.CategoryDescription}</TableCell>
                  <TableCell align="center">
                    <Chip
                      color={defectCategory.Active === 'yes' ? 'success' : 'error'}
                      label={defectCategory.Active === 'yes' ? 'Yes' : 'No'}
                      size="small"
                      icon={defectCategory.Active === 'yes' ? <CheckCircleOutlineIcon /> : <HighlightOffIcon />}
                    />
                  </TableCell>

                  <TableCell align="center" sx={{ padding: '0' }}>
                    <IconButton
                      aria-label="Edit"
                      onClick={() => {
                        setEdit(true);
                        setOpen(true);
                        setInitialValue(defectCategory);
                      }}
                    >
                      <EditIcon color="primary" />
                    </IconButton>
                    <IconButton
                      aria-label="Delete"
                      onClick={() => {
                        setDeleteId(defectCategory.CategoryId);
                        setOpenDelete(true);
                      }}
                    >
                      <DeleteForeverIcon color="error" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={11} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalRows}
          rowsPerPage={rowsPerPage}
          page={currentPage} // Use the calculated currentPage value
          onPageChange={(event, newPage) => setPage(newPage)}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0); // Reset the page when rowsPerPage changes
          }}
          mt={2}
        />
        <Grid m={2}>
          {/* add new popup form dialog box */}
          <Dialog maxWidth={'sm'} open={open} onClose={handleCloseDialog} fullWidth>
            <Container component={Paper} elevation={2} style={{ padding: '7px 14px' }}>
              <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} mr={1}>
                <Typography variant="h6" textAlign={'left'} pl={2} fontWeight={600} color="primary">
                  {edit ? 'Edit' : 'Add'} Defect Category
                </Typography>
                <IconButton onClick={handleCloseDialog}>
                  <CloseIcon />
                </IconButton>
              </Stack>
              <Stack sx={{ p: 1 }}>
                <Formik
                  validationSchema={defectCategoryValidationSchema}
                  initialValues={initialValue}
                  onSubmit={async (values, { resetForm }) => {
                    if (edit) await UpdateDefectCategory(values);
                    else await InsertDefectCategory(values);
                    resetForm();
                  }}
                >
                  {({ submitForm, values, errors, handleChange, handleBlur, setFieldValue, isSubmitting }) => (
                    <Form>
                      <Grid container spacing={2} p={1} rowSpacing={3}>
                        <Grid item width={'100%'}>
                          <TextField
                            required
                            fullWidth
                            size="small"
                            label="Defect Category Description"
                            type="text"
                            name="CategoryDescription"
                            onBlur={handleBlur}
                            error={!!errors.CategoryDescription}
                            helperText={errors.CategoryDescription}
                            value={values.CategoryDescription}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item width={'100%'}>
                          <FormControl size="small" fullWidth component="fieldset">
                            <FormLabel component="legend">Active Status</FormLabel>
                            <RadioGroup row value={values.Active?.trim()} name="Active" onChange={handleChange}>
                              <FormControlLabel value="yes" control={<Radio size="small" />} label="Yes" />
                              <FormControlLabel value="No" control={<Radio size="small" />} label="No" />
                            </RadioGroup>
                            {errors.Active && (
                              <Typography
                                variant="caption"
                                color="error"
                                className={errors.Active ? 'shake-helper-text' : ''}
                              >
                                {errors.Active}
                              </Typography>
                            )}
                          </FormControl>
                        </Grid>
                      </Grid>

                      <Stack direction="row" justifyContent="center" gap={2} sx={{ textAlign: 'center', mt: 3 }}>
                        <Button
                          onClick={submitForm}
                          disabled={isSubmitting}
                          fullWidth
                          variant="contained"
                          color={edit ? 'warning' : 'primary'}
                          size="small"
                          sx={{ boxShadow: 1 }}
                        >
                          {edit ? 'Update' : 'Save'}
                        </Button>
                      </Stack>
                    </Form>
                  )}
                </Formik>
              </Stack>
            </Container>
          </Dialog>
        </Grid>
        {/* confirmation dialog */}
        <Dialog open={openDelete} onClose={handleCloseDelete} fullScreen={fullScreen} fullWidth maxWidth="xs">
          <DialogTitle id="responsive-dialog-title">Are you sure you want to delete?</DialogTitle>
          <DialogActions>
            <Button variant="contained" autoFocus onClick={handleCloseDelete} color="primary">
              Cancel
            </Button>
            <Button variant="contained" onClick={DeleteDefectCategory} color="error" autoFocus>
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </>
  );
};

export default DefectCategory;
